import { useState, useEffect } from 'react'

export const useFetchAllContracts = ({marvarApi, dispatch, onLogout}) => {
    const [contracts, setContracts] = useState([])
    const [loadingFetchContracts, setLoadingFetchContracts ] = useState(false) //estado para animacion de carga
    
    const [ execute, setExecute ] = useState(false)
    const executeFetchAllContracts = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const response = await marvarApi.get(`/leases/mgmt-management/contracts`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setLoadingFetchContracts(true)
        fetchData()
            .then((resp) => {
                setContracts(resp.data)
                setLoadingFetchContracts(false)
            })
            .catch(e => {
                console.log(e, '________ERROR')
                setLoadingFetchContracts(false)
            })
    }, [execute])

    return { contracts, loadingFetchContracts, executeFetchAllContracts }

}

export const useFetchAllTypeManagements = ({marvarApi, dispatch, onLogout}) => {
    const [typeManagements, setTypeManagements] = useState([])
    const [loadingFetchTypeManagements, setLoadingFetchTypeManagements ] = useState(false) //estado para animacion de carga
    
    const [ execute, setExecute ] = useState(false)
    const executeFetchAllTypeManagements = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const response = await marvarApi.get(`/leases/mgmt-management/type-managements`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setLoadingFetchTypeManagements(true)
        fetchData()
            .then((resp) => {
                setTypeManagements(resp.data)
                setLoadingFetchTypeManagements(false)
            })
            .catch(e => {
                console.log(e, '________ERROR')
                setLoadingFetchTypeManagements(false)
            })
    }, [execute])

    return { typeManagements, loadingFetchTypeManagements, executeFetchAllTypeManagements }

}

export const useFetchInfoContract = ({marvarApi, dispatch, onLogout, Forms}) => {

    const {FormRequestGlobal} = Forms
    const {setFormState, formState} = FormRequestGlobal

    const [loadingFetchContract, setLoadingFetchContract ] = useState(false) //estado para animacion de carga
    
    const [ execute, setExecute ] = useState(false)
    const executeFetchInfoContract = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        if (formState.idcontrato > 0) {
            try {
                const response = await marvarApi.get(`/leases/common/application/${formState.idcontrato}`)
                // console.log('[useFetchData][useFetchInfoContract] response.data ', response.data)
                return response.data
            } catch (e) {
                console.log(e)
            }
        }else{
            setLoadingFetchContract(true)
        }

    }

    useEffect(() => {
        setLoadingFetchContract(true)
        if (formState.idcontrato > 0) {
            fetchData()
                .then((resp) => {
                    const { data } = resp
                    // console.log(' data ----- ', data)
                    setFormState((prevState) => ({
                        ...prevState,
                        contrato_dia_pago: data.contrato_dia_pago || '',
                        lastPaymentDate: data.lastPaymentDate || '',
                        lastPaymentDateDone: data.lastPaymentDateDone || '',
                        dpi: data.dpi || '',
                        cliente: data.cliente || '',
                        telefono: data.telefono || '',
                        casa: data.casa || '',
                        costo_alquiler: data.costo_alquiler || '',
                        cargos_extras_total: data.cargos_extras_total || 0, 
                        deposito_total: data.deposito_total || 0,
                        ordinary_total_debt: parseFloat(data.ordinary_total_debt || 0),
                        ordinary_total_exemption: parseFloat(data.ordinary_total_exemption || 0),
                        ordinary_total_paid: parseFloat(data.ordinary_total_paid || 0),
                        extraordinary_total_debt: parseFloat(data.extraordinary_total_debt || 0),
                        extraordinary_total_exemption: parseFloat(data.extraordinary_total_exemption || 0),
                        extraordinary_total_paid: parseFloat(data.extraordinary_total_paid || 0),
                        expense_total_debt: parseFloat(data.expense_total_debt || 0),
                        expense_total_exemption: parseFloat(data.expense_total_exemption || 0),
                        expense_total_paid: parseFloat(data.expense_total_paid || 0),
                    }))
                    setLoadingFetchContract(false)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                })
        }
    }, [execute, formState.idcontrato])

    return { loadingFetchContract, executeFetchInfoContract }

}

export const useFetchInfoObservations = ({marvarApi, dispatch, onLogout, Forms}) => {

    const {FormRequestGlobal:{formState}} = Forms

    const [observations, setObservations] = useState([])
    const [loadingFetchObservations, setLoadingFetchObservations ] = useState(false) //estado para animacion de carga
    
    const [ execute, setExecute ] = useState(false)
    const executeFetchAllObservations = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        if (formState.idgestion > 0) {
            try {
                const response = await marvarApi.get(`/leases/common/log-management/${formState.idgestion}`)
                return response.data
            } catch (e) {
                console.log(e)
            }
        }else{
            setLoadingFetchObservations(true)
        }

    }

    useEffect(() => {
        setLoadingFetchObservations(true)
        if (formState.idcontrato > 0) {
            fetchData()
                .then((resp) => {
                    setObservations(resp)
                    setLoadingFetchObservations(false)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                })
        }
    }, [execute, formState.idgestion])

    return { observations, loadingFetchObservations, executeFetchAllObservations }

}

export const useFetchInfoManagement = ({marvarApi, location, globalStates, dispatch, paramsURL, onLogout, Forms}) => {

    const { idgestion } = paramsURL

    const { pathname } = location
    const urlWithoutParam = pathname.split('/')[2]; //El segundo fragmento de la URL


    const { setShowFormContract, setFormOpeningMode } = globalStates
    const { FormRequestGlobal } = Forms
    const { setFormState } = FormRequestGlobal

    // 1. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetchManagement = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            const response = await marvarApi.get(`/leases/common/management/${idgestion}`)
            console.log('[useFetchData][useFetchInfoManagement] response.data: ', response.data)

            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(idgestion > 0){
            fetchData()
                .then((resp) => {
                    const { data } = resp
                    if(data.length>0){
                        setFormState((prevState) => ({
                            ...prevState,
                            idgestion : data[0].idgestion || '',
                            idcontrato : data[0].idcontrato || '',
                            idgestiontipo : data[0].idgestiontipo || '',
                            casa : data[0].casa || '',
                            cliente : data[0].cliente || '',
                            dpi : data[0].dpi || '',
                            telefono : data[0].telefono || '',
                            contrato_dia_pago : data[0].contrato_dia_pago || '',
                            costo_alquiler : data[0].contrato_costo_alquiler || '',
                            gestion_nuevo_dia_pago : data[0].gestion_nuevo_dia_pago || '',
                            gestion_descripcion : data[0].gestion_descripcion || '',
                            aprobacion_check : data[0].aprobacion_check || '',
                            aprobacion_fecha : data[0].aprobacion_fecha || '',
                            monto_devolucion : data[0].monto_devolucion || '',
                            cargos_extras_total : data[0].cargos_extras_total || 0,
                            deposito_total : data[0].deposito_total || 0,
                            meses_ampliacion : data[0].meses_ampliacion || '',
                            legalizacion_monto : data[0].legalizacion_monto || 0,
                            legalizacion_exoneracion : data[0].legalizacion_exoneracion || 0,
                            legalizacion_pago : data[0].legalizacion_pago || 0,
                            paymentExemptionDetails : data[0].paymentExemptionDetails || [],
                            expenseExemptionDetails : data[0].expenseExemptionDetails || []
                        }))
                        if(urlWithoutParam==='edit') setFormOpeningMode('EDITABLE')
                        if(urlWithoutParam==='info') setFormOpeningMode('READONLY')
                        setShowFormContract(true)
                    } 
                })
            }
    }, [execute])

    return { executeFetchManagement }
}

export const useFetchAllCashRegisters = ({marvarApi, dispatch, onLogout}) => {
    
    const [cashRegisters, setCashRegisters] = useState([])

    const [ loadingFetchCashRegisters, setLoadingFetchCashRegisters ] = useState(false)

    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }
    
    const resetFetch = async () => {
        setCashRegisters([])
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const response = await marvarApi.get(`/leases/common/fetch-all-cash-registers`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setLoadingFetchCashRegisters(true)
        fetchData()
            .then((resp) => {
                const { data } = resp
                setCashRegisters(data)
                setLoadingFetchCashRegisters(false)
            })
            .catch(e => {
                console.log(e, '________ERROR')
                setLoadingFetchCashRegisters(false)
            })
    }, [execute])

    return { cashRegisters, loadingFetchCashRegisters, executeFetch, resetFetch }
}

export const useFetchAllBanks = ({marvarApi, dispatch, onLogout}) => {
    
    const [banks, setBanks] = useState([])

    const [ loadingFetchBanks, setLoadingFetchBanks ] = useState(false)

    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }
    
    const resetFetch = async () => {
        setBanks([])
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const response = await marvarApi.get(`/leases/common/fetch-all-banks`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setLoadingFetchBanks(true)
        fetchData()
            .then((resp) => {
                const { data } = resp

                setBanks(data)
                setLoadingFetchBanks(false)

            })
            .catch(e => {
                console.log(e, '________ERROR')
                setLoadingFetchBanks(false)
            })
    }, [execute])

    return { banks, loadingFetchBanks, executeFetch, resetFetch }
}

export const useFetchAllFiles = ({marvarApi, dispatch, onLogout}) =>{
    
    const [ paramsToSearch, setParamsToSearch ] = useState({
        idgestion: ''
    })

    const [ dataFiles, setDataFiles ] = useState([])
    
    const [ loadingFetchInfoFiles, setLoadingFetchInfoFiles ] = useState(false)
    
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            const response = await marvarApi.get(`/leases/common/fetch-all-documents-by-management/${paramsToSearch.idgestion}`)
            // console.log('[useFetchData][useFetchAllFiles] response.data ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(paramsToSearch.idgestion !== '' ){
            setLoadingFetchInfoFiles(true)
            fetchData()
                .then((resp) => {
                    setDataFiles(resp.data)
                    setLoadingFetchInfoFiles(false)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchInfoFiles(false)
                })
        }
    }, [execute])

    return {dataFiles, loadingFetchInfoFiles, executeFetch, setParamsToSearch }
}

export const useFetchManagementLegalizationPayment = ({marvarApi, dispatch, onLogout, defaultData}) => {

    const defaultParams = {
        idgestion: '',
    }

    const [paramsToSearch, setParamsToSearch] = useState(defaultParams)

    // 1. Para los datos recuperados de la BD
    const [dataLegalizationPayment, setDataLegalizationPayment] = useState([])
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchTransactions, setLoadingFetchTransactions ] = useState(false)

    // 3. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }
    
    const resetFetch = async () => {
        setDataLegalizationPayment([])
        setParamsToSearch(defaultParams)
    }

    const fetchData = async () => {
        
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try { 
            const response = await marvarApi.get(`/leases/common/fetch-management-legalization-payment/${paramsToSearch.idgestion}`)
            // console.log('[useFetchData][useFetchManagementLegalizationPayment] response.data ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(paramsToSearch.idgestion !== '' ){
            setLoadingFetchTransactions(true)
            fetchData()
                .then((resp) => {
                    // setDataLegalizationPayment(resp.rows)
                    setDataLegalizationPayment(resp.data)
                    setLoadingFetchTransactions(false)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchTransactions(false)
                })
        }
    }, [execute])

    return { dataLegalizationPayment, loadingFetchTransactions, setParamsToSearch, executeFetch, resetFetch }

}

export const useFetchSpecificLegalizationTransaction = ({marvarApi, dispatch, onLogout, Helpers, defaultData, pdfManager}) => {

    const defaultParams = {
        idmovimiento: '',
        fecthLegalizationPaymentInfo: {
            flag: false,
            refSetFormState: null
        },
        printTicketFlag: false
    }
    const [paramsToSearch, setParamsToSearch] = useState(defaultParams)

    // 1. Para los datos recuperados de la BD
    const [dataSpecificTransaction, setDataSpecificTransaction] = useState([])
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchTransactions, setLoadingFetchTransactions ] = useState(false)

    // 3. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }
    
    const resetFetch = async () => {
        setDataSpecificTransaction([])
        setParamsToSearch(defaultParams)
    }

    const fetchData = async () => {
        
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const response = await marvarApi.get(`/leases/common/fetch-specific-legalization-transaction/${paramsToSearch.idmovimiento}`)
            // console.log('[useFetchData][useFetchSpecificLegalizationTransaction] response.data ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(paramsToSearch.idmovimiento !== '' ){
            setLoadingFetchTransactions(true)
            fetchData()
                .then((resp) => {
                    // setDataSpecificTransaction(resp.rows)
                    setDataSpecificTransaction(resp.rows[0])

                    // Para extraer info de un solo contenedor
                    if(paramsToSearch.fecthLegalizationPaymentInfo?.flag){

                        paramsToSearch.fecthLegalizationPaymentInfo.refSetFormState(prevState => ({
                            ...prevState,
                            idmovimiento: resp.rows[0]?.idmovimiento || '',
                            idgestion: resp.rows[0]?.idgestion || '',
                            idcaja: resp.rows[0]?.idcaja || '',
                            idbanco: resp.rows[0]?.idbanco || '',
                            movimiento_fecha: resp.rows[0]?.movimiento_fecha || defaultData.defaultFormLegalizationPayment.movimiento_fecha,
                            movimiento_tipo: resp.rows[0]?.movimiento_tipo || '',
                            movimiento_monto: resp.rows[0]?.movimiento_monto || '',
                            movimiento_moneda: resp.rows[0]?.movimiento_moneda || '',
                            movimiento_tipo_cambio: resp.rows[0]?.movimiento_tipo_cambio || defaultData.defaultFormLegalizationPayment.movimiento_tipo_cambio,
                            movimiento_quetzales: resp.rows[0]?.movimiento_quetzales || '',
                            movimiento_dolares: resp.rows[0]?.movimiento_dolares || '',
                            movimiento_observaciones: resp.rows[0]?.movimiento_observaciones || '',
                            boleta_numero: resp.rows[0]?.boleta_numero || '',
                            boleta_foto_originalname: resp.rows[0]?.boleta_foto_originalname || '',
                            boleta_foto_filename: resp.rows[0]?.boleta_foto_filename || '',
                            boleta_foto_path: resp.rows[0]?.boleta_foto_path || '',
                            aprobacion_check: resp.rows[0]?.aprobacion_check || '',
                            aprobacion_fecha: resp.rows[0]?.aprobacion_fecha || '',
                            aprobacion_referencia_ach: resp.rows[0]?.aprobacion_referencia_ach || '',
                            aprobacion_observaciones: resp.rows[0]?.aprobacion_observaciones || ''
                        }))

                    }

                    if (paramsToSearch?.printTicketFlag === true){
                        console.log('imprimiendo PDF')
                        Helpers.drawLegalizationPaymentTicket(pdfManager, resp.rows[0])
                    }

                    setLoadingFetchTransactions(false)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchTransactions(false)
                })
        }
    }, [execute])

    return { dataSpecificTransaction, loadingFetchTransactions, setParamsToSearch, executeFetch, resetFetch }

}

export const useFetchPaymentsByContract = ({marvarApi, dispatch, onLogout}) => {

    const [paramsToSearch, setParamsToSearch] = useState({
        idcontrato: '',
        fetchPaymentsInfo: {
            flag: false,
            refSetFormState: null,
            formStateDetailsName: ''
        }
    })

    // 1. Para los datos recuperados de la BD
    const [dataPayments, setDataPayments] = useState([])
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchPaymentsByContract, setLoadingFetchPaymentsByContract ] = useState(false)

    // 3. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }
    
    const resetFetch = async () => {
        setDataPayments([])
        setParamsToSearch({
            idcontrato: ''
        })
    }

    const fetchData = async () => {
        
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const response = await marvarApi.get(`/leases/common/fetch-payments-by-contract/${paramsToSearch.idcontrato}`)
            // console.log('[useFetchData][useFetchPaymentsByContract] response.data ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(paramsToSearch.idcontrato !== '' ){
            setLoadingFetchPaymentsByContract(true)
            fetchData()
                .then((resp) => {
                    // setDataPayments(resp.rows)
                    setDataPayments(resp.data)
                    setLoadingFetchPaymentsByContract(false)

                    // Para cargar los datos obtenidos de la BD en el estado del form
                    if(paramsToSearch.fetchPaymentsInfo?.flag){
                        paramsToSearch.fetchPaymentsInfo.refSetFormState((prevState) => ({
                            ...prevState,
                            [ paramsToSearch.fetchPaymentsInfo.formStateDetailsName ] : resp.data.map((item) => ({
                                idpago: parseInt(item.idpago, 10),
                                idcontrato: parseInt(item.idcontrato, 10),
                                contrato_codigo: item.contrato_codigo,
                                info_tipo: item.info_tipo,
                                info_fecha_pago: item.info_fecha_pago,
                                info_costo_alquiler: parseFloat(item.info_costo_alquiler),
                                info_exoneracion: parseFloat(item.info_exoneracion),
                                total_cancelar: parseFloat(item.total_cancelar),
                                total_recibido: parseFloat(item.total_recibido),
                                total_saldo: parseFloat(item.total_saldo),
                                isPaid: (parseFloat(item.total_saldo) === 0 ) ? 'SI' : 'NO'
                            }))
                        }))
                    }
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchPaymentsByContract(false)
                })
        }
    }, [execute])

    return { dataPayments, loadingFetchPaymentsByContract, setParamsToSearch, executeFetch, resetFetch }

}

export const useFetchTotalDebtPaidByContract = ({marvarApi, dispatch, onLogout}) => {

    const [paramsToSearch, setParamsToSearch] = useState({
        idcontrato: '',
        fetchTotalsInfo: {
            flag: false,
            refSetFormState: null
        }
    })

    // 1. Para los datos recuperados de la BD
    const [dataTotalDebtPaid, setDataTotalDebtPaid] = useState([])
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchTotalDebtPaid, setLoadingFetchTotalDebtPaid ] = useState(false)

    // 3. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }
    
    const resetFetch = async () => {
        setDataTotalDebtPaid([])
        setParamsToSearch({
            idcontrato: ''
        })
    }

    const fetchData = async () => {
        
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const response = await marvarApi.get(`/leases/common/fetch-total-debt-paid-by-contract/${paramsToSearch.idcontrato}`)
            console.log('[useFetchData][useFetchTotalDebtPaidByContract] response.data ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(paramsToSearch.idcontrato !== '' ){
            setLoadingFetchTotalDebtPaid(true)
            fetchData()
                .then((resp) => {
                    // setDataTotalDebtPaid(resp.rows)
                    setDataTotalDebtPaid(resp.data)
                    setLoadingFetchTotalDebtPaid(false)

                    // Para cargar los datos obtenidos de la BD en el estado del form
                    if(paramsToSearch.fetchTotalsInfo?.flag){
                        paramsToSearch.fetchTotalsInfo.refSetFormState((prevState) => ({
                            ...prevState,
                            end_normal_total_debt: resp.data[0].end_normal_total_debt,
                            end_normal_total_exemption: resp.data[0].end_normal_total_exemption,
                            end_normal_total_paid: resp.data[0].end_normal_total_paid
                        }))
                    }
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchTotalDebtPaid(false)
                })
        }
    }, [execute])

    return { dataTotalDebtPaid, loadingFetchTotalDebtPaid, setParamsToSearch, executeFetch, resetFetch }

}

export const useFetchExpensesByContract = ({marvarApi, dispatch, onLogout}) => {

    const [paramsToSearch, setParamsToSearch] = useState({
        idcontrato: '',
        fetchExpensesInfo: {
            flag: false,
            refSetFormState: null,
            formStateDetailsName: ''
        }
    })

    // 1. Para los datos recuperados de la BD
    const [dataPayments, setDataPayments] = useState([])
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchExpensesByContract, setLoadingFetchExpensesByContract ] = useState(false)

    // 3. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }
    
    const resetFetch = async () => {
        setDataPayments([])
        setParamsToSearch({
            idcontrato: ''
        })
    }

    const fetchData = async () => {
        
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const response = await marvarApi.get(`/leases/common/fetch-all-extra-expenses/${paramsToSearch.idcontrato}`)
            console.log('[useFetchData][useFetchExpensesByContract] response.data ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(paramsToSearch.idcontrato !== '' ){
            setLoadingFetchExpensesByContract(true)
            fetchData()
                .then((resp) => {
                    // setDataPayments(resp.rows)
                    setDataPayments(resp.data)
                    setLoadingFetchExpensesByContract(false)

                    // Para cargar los datos obtenidos de la BD en el estado del form
                    if(paramsToSearch.fetchExpensesInfo?.flag){
                        paramsToSearch.fetchExpensesInfo.refSetFormState((prevState) => ({
                            ...prevState,
                            [ paramsToSearch.fetchExpensesInfo.formStateDetailsName ] : resp.data.map((item) => ({
                                idexpense: parseInt(item.idexpense, 10),
                                idcontrato: parseInt(item.idcontrato, 10),
                                contrato_codigo: item.contrato_codigo,
                                info_descripcion: item.info_descripcion,
                                info_fecha_pago: item.info_fecha_pago,
                                info_costo: parseFloat(item.info_costo),
                                info_exoneracion: parseFloat(item.info_exoneracion),
                                total_cancelar: parseFloat(item.total_cancelar),
                                total_recibido: parseFloat(item.total_recibido),
                                total_saldo: parseFloat(item.total_saldo),
                                isPaid: (parseFloat(item.total_saldo) === 0 ) ? 'SI' : 'NO'
                            }))
                        }))
                    }
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchExpensesByContract(false)
                })
        }
    }, [execute])

    return { dataPayments, loadingFetchExpensesByContract, setParamsToSearch, executeFetch, resetFetch }

}